export function LogoMark({ size = 24, className = "" }) {
  return (
    <img
      src="/noizbloc-logo.png"
      alt="Noizbloc"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}
